import React from 'react'

const SendIcon = () => {
    return (
        <div>
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="44" height="44" rx="6" fill="#485869" />
                <path d="M28.875 14.125C29.4062 13.8125 30.0938 14.25 29.9688 14.875L27.7188 28.375C27.6562 28.875 27.125 29.1562 26.6875 28.9688L22.8125 27.3125L20.8125 29.75C20.375 30.2812 19.5 30 19.5 29.25V26.7188L27 17.5625C27.1562 17.375 26.9062 17.1562 26.75 17.3125L17.7812 25.2188L14.4375 23.8125C13.875 23.5938 13.8125 22.7812 14.375 22.4688L28.875 14.125Z" fill="white" />
            </svg>
        </div>
    )
}

export default SendIcon

